import loadingGif from '../../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import axios from 'axios';
import AuthService from '../../../Auth/AuthService.js';
import { settings } from '../../../Helpers/Settings.js';
import { decodeToken, isExpired } from "react-jwt";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import DatePicker from "react-datepicker";

function GridMasraf({projeId}) {
    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(/*null*/ true);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [masrafTuruIdInsert, setMasrafTuruIdInsert] = useState(0);
    const [paraBirimiIdInsert, setParaBirimiIdInsert] = useState(0);
    const [masrafInsert, setMasrafInsert] = useState(0);
    const [kurInsert, setKurInsert] = useState(0);
    const [kurTarihiInsert, setKurTarihiInsert] = useState(null);
    const [kdvOraniInsert, setKdvOraniInsert] = useState(0);
    const [aciklamaInsert, setAciklamaInsert] = useState("");

    const [masrafTuruIdUpdate, setMasrafTuruIdUpdate] = useState(0);
    const [paraBirimiIdUpdate, setParaBirimiIdUpdate] = useState(0);
    const [masrafUpdate, setMasrafUpdate] = useState(0);
    const [kurUpdate, setKurUpdate] = useState(0);
    const [kurTarihiUpdate, setKurTarihiUpdate] = useState(null);
    const [kdvOraniUpdate, setKdvOraniUpdate] = useState(0);
    const [aciklamaUpdate, setAciklamaUpdate] = useState("");

    const [currentId, setCurrentId] = useState(0);

    const [data, setData] = useState([]);
    const [dataSum, setDataSum] = useState({});
    const [dataParaBirimi, setDataParaBirimi] = useState([]);
    const [dataMasrafTuru, setDataMasrafTuru] = useState([]);

    const days = ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct']
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

    const datePickerLocale = {
      localize: {
        day: n => days[n],
        month: n => months[n]
      },
      formatLong: {
        date: () => 'dd.MM.yyyy'
      }
    }

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [projeId]);

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        //const apiurl = process.env.REACT_APP_API_URL;

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Sil"));

            setDataParaBirimi((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/ParaBirimi", { headers: AuthService.getHeaders() })).data.value);
            setDataMasrafTuru((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/MasrafTuru", { headers: AuthService.getHeaders() })).data.value);
        }
    }

    const getData = async () => {
        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Proje/GetProjeMasrafList/' + projeId + '/0', { headers: AuthService.getHeaders() });

            if (res) {
                const array = res.data.value;

                setData(array);

                let sumMasraf = 0;
                let sumKdv = 0;
                let sumKdvliMasraf = 0;
                let sumOdenenMasraf = 0;
                let sumOdenenKdv = 0;
                let sumOdenenToplam = 0;
                let sumKalan = 0;

                let sumMasrafTL = 0;
                let sumKdvTL = 0;
                let sumKdvliMasrafTL = 0;
                let sumOdenenMasrafTL = 0;
                let sumOdenenKdvTL = 0;
                let sumOdenenToplamTL = 0;
                let sumKalanTL = 0;

                for (let index = 0; index < array.length; index++) {
                    let element = array[index];

                    sumMasraf += element.masraf;
                    sumKdv += element.kdv;
                    sumKdvliMasraf += element.kdvliMasraf;
                    sumOdenenMasraf += element.odenenMasraf;
                    sumOdenenKdv += element.odenenKdv;
                    sumOdenenToplam += element.odenenToplam;
                    sumKalan += element.kalan;

                    sumMasrafTL += element.masrafTL;
                    sumKdvTL += element.kdvTL;
                    sumKdvliMasrafTL += element.kdvliMasrafTL;
                    sumOdenenMasrafTL += element.odenenMasrafTL;
                    sumOdenenKdvTL += element.odenenKdvTL;
                    sumOdenenToplamTL += element.odenenToplamTL;
                    sumKalanTL += element.kalanTL;
                }

                setDataSum({
                    "sumMasraf": sumMasraf,
                    "sumKdv": sumKdv,
                    "sumKdvliMasraf": sumKdvliMasraf,
                    "sumOdenenMasraf": sumOdenenMasraf,
                    "sumOdenenKdv": sumOdenenKdv,
                    "sumOdenenToplam": sumOdenenToplam,
                    "sumKalan": sumKalan,

                    "sumMasrafTL": sumMasrafTL,
                    "sumKdvTL": sumKdvTL,
                    "sumKdvliMasrafTL": sumKdvliMasrafTL,
                    "sumOdenenMasrafTL": sumOdenenMasrafTL,
                    "sumOdenenKdvTL": sumOdenenKdvTL,
                    "sumOdenenToplamTL": sumOdenenToplamTL,
                    "sumKalanTL": sumKalanTL
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Proje/GetProjeMasrafList/0/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setMasrafTuruIdUpdate(result.data.value[0].masrafTuruId);
                setParaBirimiIdUpdate(result.data.value[0].paraBirimiId);
                setMasrafUpdate(result.data.value[0].masraf);
                setKurUpdate(result.data.value[0].kur);
                setKurTarihiUpdate(result.data.value[0].kurTarihi);
                setKdvOraniUpdate(result.data.value[0].kdvOrani);
                setAciklamaUpdate(result.data.value[0].aciklama);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Proje/GetProjeMasrafList/0/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Proje/DeleteProjeMasraf', [resultGet.data.value[0]], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                await getData();

                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async (kayitModu) => {
        if (tokenYenile() === false) {
            return;
        }
        
        let masrafTuruId = kayitModu === "insert" ? masrafTuruIdInsert : masrafTuruIdUpdate;
        let paraBirimiId = kayitModu === "insert" ? paraBirimiIdInsert : paraBirimiIdUpdate;
        let masraf = kayitModu === "insert" ? masrafInsert : masrafUpdate;
        let kur = kayitModu === "insert" ? kurInsert : kurUpdate;
        let kurTarihi = kayitModu === "insert" ? kurTarihiInsert : kurTarihiUpdate;
        let kdvOrani = kayitModu === "insert" ? kdvOraniInsert : kdvOraniUpdate;
        let aciklama = kayitModu === "insert" ? aciklamaInsert : aciklamaUpdate;

        if (Number(masrafTuruId) === 0  || Number(paraBirimiId) === 0 || Number(masraf) === 0) {
            Swal.fire({ title: "Hata", text: "Lütfen masraf türü, para birimi ve masraf tutarı bilgilerini giriniz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": kayitModu === "insert" ? 0 : currentId,
                    "projeId": projeId,
                    "masrafTuruId": masrafTuruId,
                    "paraBirimiId": paraBirimiId,
                    "masraf": masraf,
                    "kur": kur,
                    "kurTarihi": kurTarihi ? moment(kurTarihi).format('YYYY-MM-DD') : null,
                    "kdvOrani": kdvOrani,
                    "aciklama": aciklama
                });

                const result = await axios.post(settings.ApiUrl + 'Proje/InsertOrUpdateProjeMasraf/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        await getData();

                        setCurrentId(0);

                        if (kayitModu === "insert") {
                            setMasrafTuruIdInsert(0);
                            setParaBirimiIdInsert(0);
                            setMasrafInsert(0);
                            setKurInsert(0);
                            setKurTarihiInsert(null);
                            setKdvOraniInsert(0);
                            setAciklamaInsert("");
                        }

                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const Vazgec = async () => {
        setCurrentId(0);
    }

    return (
        <Fragment>
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <React.Fragment>
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                            <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div className="card">
                                    <div className="card-body mt-4">
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{width:"25%"}}>Masraf Türü</th>
                                                        <th style={{textAlign:"center", width:"5%"}}>Para Birimi</th>
                                                        <th style={{textAlign:"center", width:"5%"}}>Kur</th>
                                                        <th style={{textAlign:"center", width:"5%"}}>Kur Tarihi</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Masraf Tutarı</th>
                                                        <th style={{textAlign:"center", width:"5%"}}>Kdv Oranı</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Kdv</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Kdv Dahil Masraf Tutarı</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Ödenen Masraf Tutarı</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Ödenen Kdv</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Ödenen Toplam</th>
                                                        <th style={{textAlign:"right", width:"5%"}}>Kalan</th>
                                                        <th style={{textAlign:"center", width:"15%"}}>Açıklama</th>
                                                        <th style={{textAlign:"center", width:"5%"}}></th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{textAlign:"center"}}>
                                                            <select className="form-select form-select-sm" value={masrafTuruIdInsert} onChange={async (e) => setMasrafTuruIdInsert(e.target.value)}>
                                                                <option value={0}></option>
                                                                {
                                                                    dataMasrafTuru && dataMasrafTuru.length > 0 ?
                                                                    dataMasrafTuru.map((item, index) => {
                                                                        return (
                                                                            <option key={index} value={item.id}>{item.ad}</option>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                                }
                                                            </select>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <select className="form-select form-select-sm" value={paraBirimiIdInsert} onChange={async (e) => setParaBirimiIdInsert(e.target.value)}>
                                                                <option value={0}></option>
                                                                {
                                                                    dataParaBirimi && dataParaBirimi.length > 0 ?
                                                                    dataParaBirimi.map((item, index) => {
                                                                        return (
                                                                            <option key={index} value={item.id}>{item.ad}</option>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                                }
                                                            </select>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kurInsert} onChange={(e) => setKurInsert(e.target.value)}></input>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <DatePicker className="form-control form-control-sm text-center" calendarStartDay={1} todayButton="Bugün" locale={datePickerLocale} dateFormat="dd.MM.yyyy" selected={kurTarihiInsert} onChange={(update) => { setKurTarihiInsert(update); }} />
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"right"}} value={masrafInsert} onChange={(e) => setMasrafInsert(e.target.value)}></input>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kdvOraniInsert} onChange={(e) => setKdvOraniInsert(e.target.value)}></input>
                                                        </th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th>
                                                            <input type="text" className="form-control form-control-sm" value={aciklamaInsert} onChange={(e) => setAciklamaInsert(e.target.value)}></input>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("insert")}><i className="bi bi-plus-circle"></i></button> : '' }
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length > 0 ?
                                                            data.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <select className="form-select form-select-sm" value={masrafTuruIdUpdate} onChange={async (e) => setMasrafTuruIdUpdate(e.target.value)}>
                                                                                        <option value={0}></option>
                                                                                        {
                                                                                            dataMasrafTuru && dataMasrafTuru.length > 0 ?
                                                                                            dataMasrafTuru.map((item, index) => {
                                                                                                return (
                                                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                                                )
                                                                                            })
                                                                                            :
                                                                                            null
                                                                                        }
                                                                                    </select>
                                                                                    :
                                                                                    item.masrafTuru
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <select className="form-select form-select-sm" value={paraBirimiIdUpdate} onChange={async (e) => setParaBirimiIdUpdate(e.target.value)}>
                                                                                        <option value={0}></option>
                                                                                        {
                                                                                            dataParaBirimi && dataParaBirimi.length > 0 ?
                                                                                            dataParaBirimi.map((item, index) => {
                                                                                                return (
                                                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                                                )
                                                                                            })
                                                                                            :
                                                                                            null
                                                                                        }
                                                                                    </select>
                                                                                    :
                                                                                    item.paraBirimi
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kurUpdate} onChange={(e) => setKurUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.kur.toLocaleString('tr-TR', {minimumFractionDigits:4, maximumFractionDigits:4})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <DatePicker className="form-control form-control-sm text-center" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" locale={datePickerLocale} selected={kurTarihiUpdate} onChange={(update) => { setKurTarihiUpdate(update); }} />
                                                                                    :
                                                                                    item.kurTarihi ? moment(item.kurTarihi).format('DD.MM.YYYY') : ""
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"right"}} value={masrafUpdate} onChange={(e) => setMasrafUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.paraBirimi + item.masraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                    "₺" + item.masrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kdvOraniUpdate} onChange={(e) => setKdvOraniUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.kdvOrani.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.kdv.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.kdvTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.kdvliMasraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.kdvliMasrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.odenenMasraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.odenenMasrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.odenenKdv.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.odenenKdvTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.odenenToplam.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.odenenToplamTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                            {
                                                                                item.paraBirimi + item.kalan.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                "₺" + item.kalanTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="text" className="form-control form-control-sm" value={aciklamaUpdate} onChange={(e) => setAciklamaUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.aciklama
                                                                            }
                                                                        </td>
                                                                        <td align="center">
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <div className="btn-group">
                                                                                        <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("update")}><i className="bi bi-check-circle"></i></button>
                                                                                        <button className="btn btn-sm btn-icon text-danger" onClick={() => Vazgec()}><i className="bi bi-x-circle"></i></button>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="btn-group">
                                                                                        { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                                        { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                                    </div>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td align="center" colSpan="14" style={{height:"48px"}}>
                                                                    Kayıt yok
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                                {
                                                    dataSum && dataSum.sumMasraf > 0 ?
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={4} style={{textAlign:"center"}}>Toplam</th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumMasraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumMasrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th></th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumKdv.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumKdvTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumKdvliMasraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumKdvliMasrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumOdenenMasraf.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumOdenenMasrafTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumOdenenKdv.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumOdenenKdvTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumOdenenToplam.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumOdenenToplamTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th style={{textAlign:"right", whiteSpace:"pre-line"}}>
                                                                {
                                                                    dataSum.sumKalan.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                    "₺" + dataSum.sumKalanTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                }
                                                            </th>
                                                            <th></th>
                                                            <th></th>
                                                        </tr>                                                        
                                                    </tfoot>
                                                    :
                                                    null
                                                }
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        :
                        ""
            }
        </Fragment>
    );
};

export default GridMasraf;